// externals
import type { FC } from 'react';

// libraries
import { Typography } from '@interstate/components/Typography';
import { Grid } from '@interstate/components/Grid';
import { FlexCol, FlexRow } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { TradeReconValuationSectionProps } from '@makemydeal/dr-dash-store/types/tradeReconCostTypes';

import { ValuationContainer as Container, InputsGrid } from '../tradeReconCost.styles';

export const TradeReconValuationSection: FC<TradeReconValuationSectionProps> = ({
    tradeKey,
    value,
    acv,
    amountOwed,
    onValuationChange
}) => {
    return (
        <Container>
            <FlexCol>
                <FlexRow justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Valuation</Typography>
                </FlexRow>
            </FlexCol>
            <InputsGrid>
                <Grid xs={12} sm={6} md={6} lg={4} xl={3}>
                    <NumericInput
                        name="Allowance"
                        label="Allowance"
                        value={value.toString()}
                        onChange={onValuationChange(tradeKey, 'value')}
                        inputPrefix="$"
                        allowDecimal
                        allowNegative={false}
                        data-testid={`${tradeKey}-allowance-input`}
                        size="sm"
                        selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={4} xl={3}>
                    <NumericInput
                        name="ACV"
                        label="ACV"
                        value={acv.toString()}
                        onChange={onValuationChange(tradeKey, 'acv')}
                        inputPrefix="$"
                        allowNegative={false}
                        data-testid={`${tradeKey}-acv-input`}
                        size="sm"
                        selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={4} xl={3}>
                    <NumericInput
                        name="Payoff"
                        label="Payoff"
                        value={amountOwed.toString()}
                        onChange={onValuationChange(tradeKey, 'amountOwed')}
                        inputPrefix="$"
                        allowNegative={false}
                        data-testid={`${tradeKey}-payoff-input`}
                        size="sm"
                        selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                    />
                </Grid>
            </InputsGrid>
        </Container>
    );
};

export default TradeReconValuationSection;
